module.exports = __webpack_public_path__ + "media/images/main_nav_profile-0c6fa1dc6a39839354d51d40ed2aeb7e.png";